import React from 'react';
import { BookOpenIcon } from 'lucide-react';
export function LearningSection() {
  return <section className="w-full bg-bg-primary py-16 md:py-24 px-4" data-id="element-372">
      <div className="max-w-5xl mx-auto" data-id="element-373">
        <div className="text-center mb-12 md:mb-16" data-id="element-374">
          <div className="inline-flex items-center justify-center w-12 h-12 md:w-16 md:h-16 bg-cta/10 rounded-full mb-4 md:mb-6" data-id="element-375">
            <BookOpenIcon className="w-6 h-6 md:w-8 md:h-8 text-cta" data-id="element-376" />
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6" data-id="element-377">
            Qué aprenderás
          </h2>
          <p className="text-base md:text-xl text-text-secondary leading-relaxed max-w-3xl mx-auto" data-id="element-378">
            Dominarás cada aspecto del sistema empresarial en Estados Unidos,
            desde el registro hasta el cumplimiento continuo.
          </p>
        </div>

        <div className="space-y-4 md:space-y-6" data-id="element-379">
          <div className="bg-bg-card p-6 md:p-8 rounded-lg border-l-4 border-cta" data-id="element-380">
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3 text-cta" data-id="element-381">
              Registrar correctamente tu empresa
            </h3>
            <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-382">
              Aprenderás a elegir la estructura legal correcta (LLC o
              Corporation), completar el registro ante el Secretary of State, y
              crear tu Operating Agreement para establecer la base legal de tu
              empresa.
            </p>
          </div>

          <div className="bg-bg-card p-6 md:p-8 rounded-lg border-l-4 border-cta" data-id="element-383">
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3 text-cta" data-id="element-384">
              Entender el sistema empresarial en EE.UU.
            </h3>
            <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-385">
              Comprenderás cómo funciona el sistema legal, fiscal y financiero
              empresarial en Estados Unidos, y cómo navegar cada aspecto
              correctamente.
            </p>
          </div>

          <div className="bg-bg-card p-6 md:p-8 rounded-lg border-l-4 border-cta" data-id="element-386">
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3 text-cta" data-id="element-387">
              Obtener tu EIN correctamente
            </h3>
            <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-388">
              Dominarás el proceso completo para obtener tu Employer
              Identification Number (EIN) y configurar correctamente la
              identidad fiscal de tu empresa ante el IRS.
            </p>
          </div>

          <div className="bg-bg-card p-6 md:p-8 rounded-lg border-l-4 border-cta" data-id="element-389">
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3 text-cta" data-id="element-390">
              Abrir tu cuenta bancaria empresarial correctamente
            </h3>
            <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-391">
              Aprenderás el proceso exacto para abrir tu cuenta bancaria
              empresarial, qué documentos necesitas, y cómo preparar tu empresa
              para la apertura.
            </p>
          </div>

          <div className="bg-bg-card p-6 md:p-8 rounded-lg border-l-4 border-cta" data-id="element-392">
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3 text-cta" data-id="element-393">
              Separar tus finanzas personales de las empresariales
            </h3>
            <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-394">
              Entenderás por qué es crítico mantener las finanzas separadas y
              cómo implementar esta separación correctamente para proteger tu
              patrimonio personal.
            </p>
          </div>

          <div className="bg-bg-card p-6 md:p-8 rounded-lg border-l-4 border-cta" data-id="element-395">
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3 text-cta" data-id="element-396">
              Cumplir correctamente con tus obligaciones
            </h3>
            <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-397">
              Dominarás el Calendario del Dueño: cuándo presentar Annual
              Reports, cómo cumplir con obligaciones fiscales, supervisar la
              contabilidad, y mantener las renovaciones al día.
            </p>
          </div>

          <div className="bg-bg-card p-6 md:p-8 rounded-lg border-l-4 border-cta" data-id="element-398">
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3 text-cta" data-id="element-399">
              Tener control completo sobre tu empresa
            </h3>
            <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-400">
              Tendrás el conocimiento completo para operar tu empresa con
              confianza, entender cada aspecto de su estructura, y tomar
              decisiones informadas sobre su futuro.
            </p>
          </div>
        </div>
      </div>
    </section>;
}